'use strict';

const events = require('dom-events');

const utils = require('../utils.js');

const CommentItem = require('./comment-item.js');
const ReplyList = require('./reply-list.js');

function Comment (data) {
  CommentItem.apply(this, Array.prototype.slice.call(arguments));

  this.tpl = {
    comment: '[data-template="community-comment"]',
    avatar: '[data-template="community-comment-avatar"]',
    authorLink: '[data-template="community-comment-author-link"]',
    author: '[data-template="community-comment-author"]',
    datetime: '[data-template="community-comment-datetime"]',
    content: '[data-template="community-comment-content"]',
    replies: '[data-template="community-comment-replies"]',
    replyButton: '[data-template="community-comment-reply-button"]'
  };

  this.date = new Date(data.CreatedAt);
  this.id = this.date.getTime().toString();

  this.refs = {
    comment: '[data-ref="community-comment-' + this.id + '"]',
    avatar: '[data-ref="community-comment-avatar-' + this.id + '"]',
    authorLink: '[data-ref="community-comment-author-link-' + this.id + '"]',
    author: '[data-ref="community-comment-author-' + this.id + '"]',
    datetime: '[data-ref="community-comment-datetime-' + this.id + '"]',
    content: '[data-ref="community-comment-content-' + this.id + '"]',
    replies: '[data-ref="community-comment-replies-' + this.id + '"]',
    replyButton: '[data-ref="community-comment-reply-button-' + this.id + '"]'
  };

  this.replyList = new ReplyList(this.id);
}

Comment.prototype = new CommentItem();

Comment.prototype.buildHTML = function () {
  var html = CommentItem.prototype.buildHTML.call(this);

  var replies = html.querySelector(this.tpl.replies);
  replies.setAttribute(
    'data-ref',
    replies.getAttribute('data-template') + '-' + this.id
  );
  replies.removeAttribute('data-template');

  var replyButton = html.querySelector(this.tpl.replyButton);
  replyButton.setAttribute(
    'data-ref',
    replyButton.getAttribute('data-template') + '-' + this.id
  );
  replyButton.removeAttribute('data-template');

  return html;
};

Comment.prototype.appendReply = function (data) {
  var replyHTML = this.replyList.appendReply(data);
  var repliesRoot = this.getHTML().querySelector(this.refs.replies);
  this.replyList.appendReplies(repliesRoot);
  return replyHTML;
};

Comment.prototype.onClick = function (event) {
  var replyButton = utils.findTarget(this.refs.replyButton, event);
  if (replyButton) {
    event.preventDefault();
    events.emit(document, 'prepareReply', {
      bubbles: true,
      dest: replyButton.parentNode,
      replyButton: replyButton,
      data: this.data
    });
  }
};

Comment.prototype.bindEvents = function () {
  CommentItem.prototype.bindEvents.call(this);

  this.onClick = this.onClick.bind(this);
  events.on(document, 'click', this.onClick);
};

module.exports = Comment;



//////////////////
// WEBPACK FOOTER
// ./_js/comments/comment.js
// module id = 31
// module chunks = 0